import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import type { TimeRangeValue } from '../components/TimeRangeFilter';

dayjs.extend(utc);
dayjs.extend(timezone);

// 后端 GraphQL Input 的 rangeStart / rangeEnd 是 ISO-8601 UTC 字符串
// （未注册 Instant scalar，后端用 Instant.parse 反序列化）
export interface IsoRange {
    rangeStart: string;
    rangeEnd: string;
}

/**
 * 仅用作「墙上时间的传输编码」，不代表看板的业务时区。
 *
 * 数仓 inhub_sorting_* / inhub_transport_* 的 stat_date + stat_hour 是 hub 当地时间，
 * 而后端固定按 America/Los_Angeles 把 Instant 拆成 date/hour。选择器上的数字要原样落到
 * stat_date/stat_hour，就得把它编码成「美西墙上时间等于这组数字」的 Instant，让后端拆回来
 * 还是同一组数字，中间不做任何真实时区换算。
 */
export const INHUB_WIRE_ZONE = 'America/Los_Angeles';

const toIso = (d: dayjs.Dayjs): string =>
    dayjs.tz(d.format('YYYY-MM-DD HH:mm:ss'), INHUB_WIRE_ZONE).toISOString();

/** 把 toIso 编码过的 ISO 串还原成原始墙上时间数字，供展示侧使用 */
export const fromWireIso = (iso: string): dayjs.Dayjs => dayjs(iso).tz(INHUB_WIRE_ZONE);

export const toIsoRange = (value: TimeRangeValue): IsoRange => {
    const now = dayjs();
    if (value.preset === 'LAST_24H') {
        return { rangeStart: toIso(now.subtract(24, 'hour')), rangeEnd: toIso(now) };
    }
    if (value.preset === 'LAST_48H') {
        return { rangeStart: toIso(now.subtract(48, 'hour')), rangeEnd: toIso(now) };
    }
    if (value.preset === 'CUSTOM' && value.customRange) {
        return { rangeStart: toIso(value.customRange[0]), rangeEnd: toIso(value.customRange[1]) };
    }
    return { rangeStart: toIso(now.subtract(24, 'hour')), rangeEnd: toIso(now) };
};
